import React, { Component } from 'react'
import Fade from 'react-reveal/Fade'
import { CoverImg } from '../index'
import { press, nyt, nypost, huffpost, dailynews, fox5, fox, mnn, courttv } from '../../assets/imgs'
import './index.css'
import { isMobile } from '../../services'

const allArticles = [{
  desc: 'Judge ultimately acquits defendant of Disorderly Conduct charges after two-day bench trial.',
  link: 'http://www.nytimes.com/2013/10/12/nyregion/interns-team-with-bronx-lawyers-to-help-poor-navigate-a-notorious-court-system.html',
  img: nyt,
  imgClassName: 'press__nyt'
}, {
  desc: 'Jury acquits defendant of Manslaughter and Criminally Negligent Homicide charges after five-week trial.',
  link: 'http://www.nydailynews.com/new-york/bronx/drunk-driver-90-days-jail-killing-bronx-man-article-1.1738453',
  img: dailynews,
  imgClassName: 'press__daily-news'
}, {
  desc: 'Felony Rape charges ultimately dismissed outright.',
  link: 'https://nypost.com/2017/06/21/male-model-apologized-after-allegedly-raping-the-wrong-roommate/',
  img: nypost,
  imgClassName: 'press__ny-post'
}, {
  desc: 'Defendant\'s release from jail secured after high-profile Upper West Side explosion.',
  link: 'http://www.nydailynews.com/new-york/manhattan/man-bail-blow-nyc-home-suicide-bid-article-1.3763451',
  img: dailynews,
  imgClassName: 'press__daily-news'
}, {
  desc: 'Fabricated Marijuana charges against beloved teacher ultimately dismissed and sealed.',
  link: 'https://www.huffingtonpost.com/2013/12/09/alberto-willmore_n_4412610.html',
  img: huffpost,
  imgClassName: 'press__huff-post'
}, {
  desc: 'Phillip Hamilton discussing Mayor De Blasio’s new criminal justice plan.',
  link: 'https://www.msn.com/en-us/video/be-prepared/nyc-mayor-bill-de-blasios-new-criminal-justice-plan-sparks-outrage/vp-AACbTMg',
  img: fox,
  imgClassName: 'press__fox'
}, {
  desc: 'Phillip Hamilton discussing the state of the Democratic Party and the outlook for the 2020 election.',
  link: 'https://video.foxnews.com/v/6011390190001/?playlist_id=5410209611001#sp=show-clips',
  img: fox,
  imgClassName: 'press__fox'
}, {
  desc: 'Phillip Hamilton discussing NY marijuana law and the outlook for legalization.',
  link: 'http://lisaevers.com/street-soldiers-tv-mainstreaming-marijuana',
  img: fox5,
  imgClassName: 'press__fox'
}, {
  desc: 'Felony Assault charges negotiated to non-criminal infraction with no jail time.',
  link: 'http://www.nydailynews.com/new-york/bronx/bronx-school-teacher-arrested-robbing-student-drug-money-article-1.2803712',
  img: dailynews,
  imgClassName: 'press__daily-news'
}, {
  desc: 'Felony Grand Larceny charges ultimately negotiated to lesser plea with no jail time.',
  link: 'http://www.nydailynews.com/new-york/nyc-crime/thief-leaps-hudson-stealing-taxi-manhattan-article-1.3608781',
  img: dailynews,
  imgClassName: 'press__daily-news'
}, {
  desc: 'Phillip Hamilton discussing constitutional rights during police encounters.',
  link: 'https://youtu.be/nwqSJw0STi0',
  img: mnn,
  imgClassName: 'press__mnn'
}, {
  desc: 'Phillip Hamilton discussing the art and nuances of effective criminal defense.',
  link: 'http://x-default-stgec.uplynk.com/ausw/slices/576/5a41d9ac062d41bbb88c8ded2e0ef1c0/576de9881460495fa7bbca540df704b9/576de9881460495fa7bbca540df704b9_e.mp4',
  img: courttv,
  imgClassName: 'press__courttv'
}]

class Press extends Component {
  constructor () {
    super()
    this.state = { showAll: !isMobile() }
    this.seeMore = this.seeMore.bind(this)
  }

  seeMore () {
    this.setState({ showAll: true })
  }

  render () {
    const { showAll } = this.state
    const articles = showAll ? allArticles : allArticles.slice(0, 4)
    return (
      <div className="bg-cream">
        <Fade>
          <CoverImg alt="press" src={press} disclaimer />
        </Fade>
        <Fade>
          <div className="press__content pv3 ph2 pa4-m pa5-l m0-auto-ns">
            <h2 className="serif fw4 f3 tc mb5 f1-ns mb7-ns">In the Media</h2>
            <div className="overflow-hidden w-100 relative flex flex-row flex-wrap">
              {articles.map(({ desc, link, img, imgClassName }, i) => (
                <a className="press__article relative w-50 mb6 w-third-l mb7-l" key={i} href={link}>
                  <div className="flex flex-column items-start h-100 ph1 ph2-m ph3-l">
                    <div className="press__article-border w-100 mb2"></div>
                    <img className={`press__article-img ${imgClassName}`} src={img} alt='press logo' />
                    <div className="press__article-text black">
                      <div className="fw3 f7 f5-m f3-l mb2 mb4-ns">{desc}</div>
                    </div>
                  </div>
                </a>
              ))}
            </div>
            {!showAll && (<span className="db tc fw3 f7 red pointer" onClick={this.seeMore}>
              See more
            </span>)}
          </div>
        </Fade>
      </div>
    )
  }
}

export default Press



// WEBPACK FOOTER //
// ./src/components/press/index.js